import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { NOT_LOADED } from "../Infra/RemoteData";
import { AdminPasswordSettingsViewParent } from "./AdminPasswordSettingsView.styles";
import { AdminPasswordSettingsViewModel } from "./AdminPasswordSettingsViewModel";
import { AdminFormHolder, AdminFormSection } from "./AdminFormShared.styles";
import { ButtonArea, SaveButton, SaveIcon } from "./AdminUserFormBase.styles";
import { useFormHelper } from "./FormHelper";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { HXTextField } from "./base.styles";
import { useViewModel } from "./useViewModel";
export const AdminPasswordSettingsView = observer((props) => {
    const model = useViewModel(AdminPasswordSettingsViewModel, props);
    const formHelper = useFormHelper(model.formModel);
    if (model.organization === NOT_LOADED) {
        return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
    }
    return (_jsx(AdminPasswordSettingsViewParent, { children: _jsxs(AdminFormHolder, { children: [_jsxs(AdminFormSection, { children: [_jsx(HXTextField, { ...formHelper.bindNumericField("passwordExpiryInDays"), label: "Password Expiry (In days)" }), _jsx(HXTextField, { ...formHelper.bindNumericField("minPasswordLength"), label: "Minimum Password Length" })] }), _jsx(ButtonArea, { children: _jsx(SaveButton, { startIcon: _jsx(SaveIcon, {}), onClick: () => model.save(), children: "Save" }) })] }) }));
});
